import React from 'react'

function initials(text) {
  if (!text) return '?'
  return text
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0].toUpperCase())
    .join('')
}

export function Avatar({ name, size = 32 }) {
  return (
    <span
      aria-hidden
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        borderRadius: '50%',
        background: 'var(--neutral-bg, #e5e7eb)',
        color: 'var(--neutral-text, #374151)',
        fontSize: Math.round(size * 0.4),
        fontWeight: 600,
      }}
    >
      {initials(name)}
    </span>
  )
}
